import { lazy } from "react";
import { Navigate, type RouteObject } from "react-router-dom";
import { RouteError } from "./RouteError";
import { BillingPage, ForgotPasswordPage, ResetPasswordPage, SignInPage, SignUpPage } from "../features/auth/auth";
import LandingPage from "../features/landing/LandingPage";
import { LegalPage } from "../features/legal/LegalPage";
import { AnalyticsRouteTracker } from "../features/analytics/analytics";
import { ScrollToTop } from "./ScrollToTop";
import BlogHubPage from "../features/blog/BlogHubPage";
import BlogArticlePage from "../features/blog/BlogArticlePage";

const AiEditor = lazy(async () => import("../features/ai/AiEditor"));
const AiVectorEditor = lazy(async () => import("../features/ai/AiVectorEditor"));
const AiHybridEditor = lazy(async () => import("../features/ai/AiHybridEditor"));
const AiRealismEditor = lazy(async () => import("../features/ai/AiRealismEditor"));
const AdminPhotos = lazy(async () => import("../features/admin/AdminPhotos"));

const routes: RouteObject[] = [
  { path: "/admin/photos", element: <AdminPhotos />, errorElement: <RouteError /> },
  { path: "/blog", element: <BlogHubPage />, errorElement: <RouteError /> },
  { path: "/blog/:slug", element: <BlogArticlePage />, errorElement: <RouteError /> },
  { path: "/blog/*", element: <BlogArticlePage />, errorElement: <RouteError /> },
  { path: "/sign-up", element: <SignUpPage />, errorElement: <RouteError /> },
  { path: "/sign-in", element: <SignInPage />, errorElement: <RouteError /> },
  { path: "/forgot-password", element: <ForgotPasswordPage />, errorElement: <RouteError /> },
  { path: "/reset-password", element: <ResetPasswordPage />, errorElement: <RouteError /> },
  { path: "/billing", element: <BillingPage />, errorElement: <RouteError /> },
  { path: "/terms", element: <LegalPage document="terms" />, errorElement: <RouteError /> },
  { path: "/terms-and-conditions", element: <Navigate replace to="/terms" /> },
  { path: "/privacy", element: <LegalPage document="privacy" />, errorElement: <RouteError /> },
  { path: "/privacy-policy", element: <Navigate replace to="/privacy" /> },
  { path: "/refund-policy", element: <LegalPage document="refund" />, errorElement: <RouteError /> },
  { path: "/ai", element: <AiEditor />, errorElement: <RouteError /> },
  { path: "/ai-2", element: <AiVectorEditor />, errorElement: <RouteError /> },
  { path: "/ai-3", element: <AiHybridEditor />, errorElement: <RouteError /> },
  { path: "/ai-4", element: <AiRealismEditor />, errorElement: <RouteError /> },
  { path: "/lp-2", element: <LandingPage variant="upload" />, errorElement: <RouteError /> },
  { path: "/", element: <LandingPage />, errorElement: <RouteError /> },
  { path: "*", element: <Navigate replace to="/ai" /> },
];

export const appRoutes: RouteObject[] = [{
  element: <><ScrollToTop /><AnalyticsRouteTracker /></>,
  children: routes,
}];
